import React from "react";
import BankList from "./../../../lib/data/bank.static";
import { getFEWalletParams } from "./../../../../platform.pay.config";

import translate from "./../../../lib/translate/TranslateJs";


/**
 * @param {string} suffixNoParam api信息中返回的展示的银行账户列表中的尾号的字段
 */
class BankAccount extends React.Component {
    static defaultProps = {
        keyName: ["bankName", "bankCode"]
    }
    constructor(props) {
        super(props);

        this.state = {
            bankIcon: ""
        }

        this.feWalletParams = getFEWalletParams();
    }
    componentDidMount() {
        const { bankAccounts, keyName, value, setFormStaticData } = this.props;
        bankAccounts && bankAccounts.length && setFormStaticData("bankaccount", value || bankAccounts[0][keyName[1]]);
    }
    componentDidUpdate(prevProps) {
        // 设置第一次进入充值的默认Code
        const { bankAccounts, keyName, value } = this.props;
        if (
            Array.isArray(bankAccounts) &&
            bankAccounts.length &&
            (
                // 简易优化深度对比
                typeof prevProps.bankAccounts !== typeof bankAccounts ||
                prevProps.bankAccounts.length !== bankAccounts.length ||
                JSON.stringify(prevProps.bankAccounts) !== JSON.stringify(bankAccounts)
            )
        ) {
            this.props.setCurrFormData(
                {
                    "bankaccount": Array.isArray(bankAccounts) && bankAccounts.length ?
                        (value || bankAccounts[0][keyName[1]])
                            : ""
                }
            );
        }
    }
    getImgName = (v) => {
        let bankAlphabetic = "card";
        const { keyName } = this.props;
        BankList.some((bankListVal) => {
            if (bankListVal.Name === v[keyName[0]]) {
                bankAlphabetic = bankListVal.Img;
                return true;
            }
        });

        return bankAlphabetic;
    }
    getBankName = (v) => {
        let bankName = "";
        const { bankAccounts, keyName } = this.props;

        bankAccounts.some((bankItem) => {
            if (bankItem[keyName[1]] === v) {
                bankName = bankItem[keyName[0]];
                return true;
            }
        });

        return bankName;
    }
    addBankInfo = () => {
        this.feWalletParams.goAddBankInfo("bank");
    }
    render() {

        const { Item, Select, Input } = this.props;
        const { label, keyName, bankAccounts, suffixNoParam, bankIconName, notRequired } = this.props;

        return Array.isArray(bankAccounts) && bankAccounts.length > 0 && !!bankAccounts[0][keyName[1]] ? 
            <Item
                fieldName="bankaccount"
                label={label || translate("存款银行")()}
                rules={[{
                    required: true,
                    message: translate("请选择银行")()
                }]}
            >
                {(control) => (
                    <Select
                        // currValue={control.value} // Web Mob use
                        // currName={this.getBankName(control.value)} // Native use
                        // getImgName={this.getImgName}
                        // onSelectChange={control.onChange}
                        // keyVal=
                        // keyName=
                        // bankIconName={bankIconName}
                        // suffixNoParam={(v) => (!!suffixNoParam ? (" - " + v[suffixNoParam]) : "")}
                        isSearch={true}
                        valueKey={keyName[1]}
                        valueName={keyName[0]}
                        // valueNumber="accountMaskNum"
                        // maskName="maskName"
                        currValue={control.value}
                        bankAccounts={bankAccounts}
                        placeholder={label || translate("选择账户")()}
                        addEvent={this.addBankInfo}
                        onSelectChange={control.onChange}
                    />
                )}
            </Item> : (notRequired ? null : <Item
                fieldName="bankaccount_other"
                label={label || translate("存款银行")()}
                rules={[{
                    required: true,
                    message: translate("请联系客服添加银行信息")()
                }]}
            >
                {() => (<Input value={translate("请联系客服添加银行信息")()} disabled />)}
            </Item>)
    }
}

export default BankAccount
